import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { formatDate } from "helper/date-time";
import { useQueryCurbArea } from "modules/curb-zone/hooks/use-query-curb-area";
import { Dispatch, SetStateAction, useState } from "react";
import { CurbArea } from "types/curb-area.type";

interface CurbAreaDetailProps {
  curbAreaDetail?: CurbArea;
  setOpenCurbAreaModal: Dispatch<SetStateAction<boolean>>;
  setCurbAreaDetail: (params: CurbArea | undefined) => void;
}
export const CurbAreaDetail = ({ curbAreaDetail, setOpenCurbAreaModal, setCurbAreaDetail }: CurbAreaDetailProps) => {
  const { handleRemoveCurbArea } = useQueryCurbArea();
  const [openConfirm, setOpenConfirm] = useState(false);
  const handleEdit = () => setOpenCurbAreaModal(true);
  const handleDelete = async () => {
    if (curbAreaDetail?.id) {
      handleRemoveCurbArea({ id: curbAreaDetail.id });
      setOpenConfirm(false);
      setCurbAreaDetail(undefined);
    }
  };
  return (
    <>
      <div className="transition-opacity absolute h-auto top-36 bg-primary p-3 right-6 mt-2 mb-3 rounded-md shadow-lg z-5 min-w-80">
        <div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Name</span>
            <span className="text-sm text-secondary text-right">{curbAreaDetail?.name}</span>
          </div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Note</span>
            <span className="text-sm text-secondary text-right">{curbAreaDetail?.note}</span>
          </div>
          {curbAreaDetail?.publishedDate && (
            <div className="flex justify-between w-full items-center py-2">
              <span className="text-sm text-secondary">Published Date</span>
              <span className="text-sm text-secondary text-right">
                {formatDate(curbAreaDetail.publishedDate, { format: "d MMM yyyy HH:mm" })}
              </span>
            </div>
          )}
        </div>
        <div className="flex justify-between mt-4">
          <Button variant="destructive" onClick={() => setOpenConfirm(true)}>
            Delete
          </Button>
          <Button variant="secondary" onClick={handleEdit}>
            Edit
          </Button>
        </div>
      </div>
      <AlertDialog open={openConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete curb area</AlertDialogTitle>
            <AlertDialogDescription>Are you sure that you want to delete this curb area?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => setOpenConfirm(false)}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={handleDelete}>Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
